import React, { useState, useEffect, useMemo, useRef } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Grid,
    Select,
    FormControl,
    InputLabel,
    MenuItem,
} from "@mui/material";
import { City, Country } from "country-state-city";
import { SelectType, Approval, Progress } from "../data";
import LocationDetectAndInput from "../LocationDetectAndInput";

const EditForm = ({ open, onClose, initialData, onSubmit }) => {

    const [formData, setFormData] = useState({
        email: "",
        // mobile: "",
        type: "",
        address: "",
        status: "",
        closeTime: "",
        openTime: "",
        country: "",
        city: "",
        progress: "",
        approvalStatus: "",
        lat: "",
        lng: "",
    });

    useEffect(() => {
        if (initialData) {
            setFormData({
                ...initialData,
                address: initialData.address,
                email: initialData.email,
                mobile: initialData.mobile,
                approvalStatus: initialData.approvalStatus,
                type: initialData.type,
                closeTime: initialData.closeTime,
                openTime: initialData.openTime,
                country: initialData.country,
                city: initialData.city,
                progress: initialData.progress,
                lat: initialData.location.coordinates[0],
                lng: initialData.location.coordinates[1],
            });
        }
    }, [initialData]);


    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSelectChange = (name, selectedOption) => {
        setFormData((prev) => ({ ...prev, [name]: selectedOption }));
    };


    const countries = useMemo(
        () =>
            Country.getAllCountries().map((country) => ({
                value: country.isoCode,
                label: `${country.name} (+${country.phonecode})`,
            })),
        []
    );

    const cities = useMemo(() => {
        return (
            City.getCitiesOfCountry(formData.country)?.map((city) => ({
                value: city.name,
                label: city.name,
            })) || []
        );
    }, [formData.country]);



    const handleSubmit = async () => {

        await onSubmit(formData);

    };

    const handleClose = () => {
        onClose();

    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{"Edit Basic Info"}</DialogTitle>
            <DialogContent dividers>
                <TextField
                    label="Email"
                    value={formData.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <LocationDetectAndInput
                    formValues={formData}
                    setFormValues={setFormData}
                    error={""}
                />


                <FormControl fullWidth margin="normal">
                    <InputLabel id="country-label">Country</InputLabel>
                    <Select
                        labelId="country-label"

                        value={formData.country}
                        onChange={(e) => handleSelectChange("country", e.target.value)}
                        label="Country"
                    >
                        {countries?.map((country, index) => (
                            <MenuItem key={index} value={country.value}>
                                {country.value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="normal">
                    <InputLabel>City</InputLabel>
                    <Select
                        className="form-control"
                        options={cities}
                        placeholder="Select City"
                        value={formData.city}
                        onChange={(e) => handleSelectChange("city", e.target.value)}
                    >
                        {cities?.map((country, index) => (
                            <MenuItem key={index} value={country.value}>
                                {country.value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <InputLabel id="type-label">Select Type</InputLabel>
                    <Select
                        labelId="type-label"
                        value={formData.type}
                        onChange={(e) => handleChange("type", e.target.value)}
                        label="Select Type"
                    >
                        {SelectType?.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="normal">
                    <InputLabel id="type-label">Approval Status</InputLabel>
                    <Select
                        labelId="type-label"
                        value={formData.approvalStatus}
                        onChange={(e) => handleChange("approvalStatus", e.target.value)}
                        label="Select Approval Status"
                    >
                        {Approval?.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <InputLabel id="type-label">Progress Status</InputLabel>
                    <Select
                        labelId="type-label"
                        value={formData.progress}
                        onChange={(e) => handleChange("progress", e.target.value)}
                        label="Select Progress Status"
                    >
                        {Progress?.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="normal">
                    {/* <InputLabel id="type-label">Operational Time (From - To)</InputLabel> */}

                    <TextField
                        type="time"
                        label="Open Time"
                        value={formData.openTime}
                        onChange={(e) => handleChange("openTime", e.target.value)}
                        fullWidth
                        margin="normal"
                    />

                    <TextField
                        type="time"
                        label="Close Time"
                        value={formData.closeTime}
                        onChange={(e) => handleChange("closeTime", e.target.value)}
                        fullWidth
                        margin="normal"
                    />
                </FormControl>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    {"Update"}
                </Button>
            </DialogActions>
        </Dialog >
    );
};

export default EditForm;
